import './index.scss'
import React, {useEffect, useRef, useState} from "react";
import {Header, ListView} from "../../../../components";
import Service from "../service";
import Library from "../../../../library";

const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram();

const SyntheticList = () => {
  const { clientId: urlClientId } = Library.Util.url.paramsToObj();
  const [userInfo, setUserInfo] = useState({});
  const [dataList, setDataList] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false)
  const currentPage = React.useRef(1)

  useEffect(() => {
    JsBridge.getCurrentUserInfo().then(setUserInfo).catch(() => {});
  }, []);

  // clientId: 小程序用 URL 参数，H5/App 用 userInfo.clientId
  const clientId = isMiniprogram ? urlClientId : userInfo?.clientId;

  useEffect(()=>{
    onRefresh(true);
  }, [])

  //加载列表数据
  const onRefresh = async (loading=false) => {
    currentPage.current = 1;
    if(loading) {
      setLoading(true)
    }
    const res = await Service.getCompoundList(
      {
        pageNum: currentPage.current,
        pageSize: 10,
        eventType: 1,
        clientId,
      },
      loading
    );
    if(loading) {
      setLoading(false)
    }
    if (res?.data) {
      const { count = 0, list = [] } = res.data;
      setDataList(list);
      setHasMore(count > list?.length);
    }
  }
  const loadMore = async () => {
    const nextPage = currentPage.current + 1;
    const res = await Service.getCompoundList(
      {
        pageNum: nextPage,
        pageSize: 10,
        eventType: 1,
        clientId,
      },
      false
    );
    if (res?.data) {
      const { count = 0, list = [] } = res.data;
      currentPage.current = nextPage;
      setDataList(prev => {
        const newList = [...prev, ...list];
        setHasMore(count > newList.length);
        return newList;
      });
    }
  }

  const renderItem = (item) => {
    return (
      <div className="syntheticListContainer">
        <div className="syntheticListTopBox">
          <div className="imgBox">
            <img src={item?.imgUrl || require('../imgs/power.png')} alt=""/>
          </div>
          <div className="syntheticListRightBox">
            <div className="powerTitle">{item?.resName}</div>
            <div className="syntheticListCount">x{item?.mergeCount}</div>
          </div>
        </div>
        <div className="syntheticListInfoBox">
          <div>合成时间：{item?.mergeTime}</div>
        </div>
      </div>
    )
  }
  return (
    <div className="syntheticListPage">
      <div>
        <Header midText="合成记录" bgColor={'#FFFFFF'}/>
      </div>
      <div className="body-container">
        <ListView
          dataSource={dataList}
          renderItem={renderItem}
          hasMore={hasMore}
          emtyDesc={loading ? '数据加载中...':'暂无数据'}
          onRefresh={onRefresh}
          loadMore={loadMore}
        />
      </div>
    </div>
  )
}
export default SyntheticList